import api from "./api";

export async function listFormasPagamento() {
  // GET /api/FormasPagamento — primeira chamada dispara lazy-seed das 6
  // formas de sistema.
  const { data } = await api.get("/FormasPagamento");
  return data;
}

export async function createFormaPagamento({ nome }) {
  const { data } = await api.post("/FormasPagamento", { nome });
  return data;
}

export async function updateFormaPagamento(id, { nome }) {
  await api.put(`/FormasPagamento/${id}`, { nome });
}

export async function deleteFormaPagamento(id) {
  // Pode retornar 400 (IsSistema) ou 409 (em uso por lançamentos/roteiros).
  await api.delete(`/FormasPagamento/${id}`);
}
